import classNames from 'classnames';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { Box, Wrapper } from '@preventx/oxygen';

// Components
import { WithIcon } from '@/slices/shared/PageHeroHeadline/WithIcon';
import { VimeoContainer } from '@/components/Display/VimeoContainer';
import { WithVideo } from '@/slices/shared/PageHeroHeadline/WithVideo';
import { WithImage } from '@/slices/shared/PageHeroHeadline/WithImage';
import { HeroContent } from '@/slices/shared/PageHeroHeadline/HeroContent';
import { WithBackgroundGraphic } from '@/slices/shared/PageHeroHeadline/WithBackgroundGraphic';

export type PageHeroHeadlineProps =
  SliceComponentProps<Content.PageHeroHeadlineSlice>;

const PageHeroHeadline = ({ slice }: PageHeroHeadlineProps) => {
  const { primary, variation } = slice;

  return (
    <Box
      component="header"
      className={classNames('hero', {
        masthead: variation === 'withBackgroundGraphic',
      })}
    >
      <Wrapper size="lg" className="h-full">
        {variation !== 'withBackgroundGraphic' && (
          <Box
            component="div"
            className="hero__columns"
            addSwitcher={
              slice.variation === 'withIcon' ||
              slice.variation === 'withImage' ||
              slice.variation === 'withVideo' ||
              slice.variation === 'withVimeo'
            }
          >
            <HeroContent slice={slice} />

            {variation === 'withIcon' && <WithIcon content={primary} />}
            {variation === 'withImage' && <WithImage content={primary} />}
            {variation === 'withVideo' && <WithVideo content={primary} />}
            {variation === 'withVimeo' && (
              <VimeoContainer vimeoId={primary.video_id ?? undefined} />
            )}
          </Box>
        )}

        {variation === 'withBackgroundGraphic' && <HeroContent slice={slice} />}
      </Wrapper>

      {variation === 'withBackgroundGraphic' && (
        <WithBackgroundGraphic content={primary} />
      )}
    </Box>
  );
};

export default PageHeroHeadline;
